import * as ExcelJS from "exceljs";
import { Combination } from "../../types";
import { isNullOrUndefined } from "../../utils";

export const readExcel = async (file: File): Promise<Combination[]> => {
    return new Promise((resolve, reject) => {
        const workbook = new ExcelJS.Workbook();
        const reader = new FileReader();

        reader.onload = async (e: ProgressEvent<FileReader>) => {
            if (e.target === null || e.target.result === null) {
                return;
            }

            const buffer: ArrayBuffer = e.target!.result as ArrayBuffer;

            try {
                // Load the Excel file buffer
                await workbook.xlsx.load(buffer);

                // Assuming the data is in the first worksheet
                const worksheet = workbook.getWorksheet(1);

                if (!worksheet) return;

                const newPreps: { [key: string]: any } = {};
                const newFactories: { [key: string]: any } = {};
                const newMarkets: { [key: string]: any } = {};
                const newItems: { [key: string]: any } = {};

                // Transform worksheet data into an array of objects
                const data: Combination[] = [];
                worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                    if (rowNumber === 1) return;

                    // const line = row.getCell(COLUMN.LINE).value as string;
                    // if (isNullOrUndefined(newFactories.get(line)))
                    //     newFactories.set(line, Object.keys(newFactories).length);
                    // const lineIndex = newFactories.get(line)!;

                    // const market = row.getCell(COLUMN.MARKET).value as string;
                    // if (isNullOrUndefined(newMarkets.get(market)))
                    //     newMarkets.set(market, Object.keys(newMarkets).length);
                    // const marketIndex = newMarkets.get(market)!;

                    // const itemCode = row.getCell(COLUMN.ITEM_CODE).value as string;
                    // if (isNullOrUndefined(newItems.get(itemCode))) newItems.set(itemCode, Object.keys(newItems).length);
                    // const itemCodeIndex = newItems.get(itemCode)!;

                    // data.push({
                    //     line,
                    //     lineIndex,
                    //     market,
                    //     marketIndex,
                    //     itemCode,
                    //     itemCodeIndex,
                    //     description: row.getCell(COLUMN.ITEM_DESCRIPTION).value as string,
                    //     variable: row.getCell(COLUMN.VARIABLE).value as string,
                    //     profit: row.getCell(COLUMN.PROFIT).value as number,
                    //     capacity: row.getCell(COLUMN.CAPACITY).value as number,
                    //     demand: row.getCell(COLUMN.DEMAND).value as number,
                    //     max_capacity: row.getCell(COLUMN.MAX_CAPACITY).value as number,
                    //     variableValue: null,
                    // });
                    // const rowData: { [key: string]: any } = {};
                    const rowData: Partial<Combination> = {};
                    row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                        switch (colNumber) {
                            // prep
                            case 1:
                                rowData.prep = cell.value as string;
                                if (isNullOrUndefined(newPreps[`${cell.value}`])) {
                                    newPreps[`${cell.value}`] = Object.keys(newPreps).length;
                                }
                                rowData.prepIndex = newPreps[`${cell.value}`];
                                break;
                            // line
                            case 2:
                                rowData.line = cell.value as string;
                                if (isNullOrUndefined(newFactories[`${cell.value}`])) {
                                    newFactories[`${cell.value}`] = Object.keys(newFactories).length;
                                }
                                rowData.lineIndex = newFactories[`${cell.value}`];
                                break;

                            // market
                            case 3:
                                rowData.market = cell.value as string;
                                if (isNullOrUndefined(newMarkets[`${cell.value}`]))
                                    newMarkets[`${cell.value}`] = Object.keys(newMarkets).length;
                                rowData.marketIndex = newMarkets[`${cell.value}`];
                                break;

                            // item code
                            case 4:
                                rowData.itemCode = cell.value as string;
                                if (isNullOrUndefined(newItems[`${cell.value}`]))
                                    newItems[`${cell.value}`] = Object.keys(newItems).length;
                                rowData.itemCodeIndex = newItems[`${cell.value}`];
                                break;

                            // item description
                            case 5:
                                rowData.description = cell.value as string;
                                break;

                            // variable
                            case 6:
                                rowData.variable = cell.value as string;
                                break;

                            // profit
                            case 7:
                                rowData.profit = cell.value as number;
                                break;

                            // demand
                            case 8:
                                rowData.demand = cell.value as number;
                                break;

                            // prep capacity
                            case 9:
                                rowData.prepCapacity = cell.value as number | string | undefined;
                                break;

                            // capacity
                            case 10:
                                rowData.capacity = cell.value as number;
                                break;

                            // prep max capacity
                            case 11:
                                rowData.prep_max_capacity = cell.value as number | string | undefined;
                                break;

                            // max capacity
                            case 12:
                                rowData.max_capacity = cell.value as number;
                                break;
                        }
                    });
                    data.push({ ...rowData, variableValue: null } as Combination);
                });

                // console.log(newFactories, newMarkets, newItems, newPreps, data);
                // console.log(data);

                resolve(data);
            } catch (error) {
                reject(error);
            }
        };

        reader.readAsArrayBuffer(file);
    });
};
